import { FactorInfluenceInfoDeleteRowsModalOpener, FactorInfluenceInfoItemModalOpener, FactorInfluenceInfoServiceModalOpener } from 'components/ais/factor-influence-info';
import {
    ProjectInvestmentInfoDeleteRowsModalOpener,
    ProjectInvestmentInfoItemModalOpener,
    ProjectInvestmentInfoServiceModalOpener,
} from 'components/ais/project-investment-info';
import {ButtonOpenLink} from 'components/directory/action/button-open-link/button-open-link';
import {
    ButtonSetCorrectionNumber,
} from 'components/documents/action/button-set-correction-number/button-set-correction-number';
import {SynthesisDocumentModalOpener} from 'components/documents/open-synthesis-document-modal';
import {DwhDataPreparationModalOpener} from 'components/dwh-data-preparation-modal';
import {ButtonEditForm} from 'components/form/actions/button-edit-form/button-edit-form';
import {ButtonFormation} from 'components/form/actions/button-formation/button-formation';
import {ButtonHistoryBack} from 'components/form/actions/button-history-back';
import {ButtonRedirect} from 'components/form/actions/button-redirect';
import {ButtonRemoveFilter} from 'components/form/actions/button-remove-filter';
import {ButtonSaveOrEditForm} from 'components/form/actions/button-save-or-edit-form';
import {ButtonSendRequestCopyResponseRequirement} from 'components/form/actions/button-send-request-copy-response-requirement';
import {
    ButtonActionDownloadReport,
} from 'components/table-report/action/button-action-download-report';
import {
    AttachmentButton,
} from 'components/table-report/components/table-report-actions/actions/attachment-button/attachment-button';
import {OpenDocumentXmlModal} from 'components/table/action/open-document-xml-modal';
import {EMetaActionType} from 'entities/metadata';
import {ButtonActionCustomLink} from 'features/provide-custom-link';

import {ButtonActionForClearRows} from './button-action-clear-rows';
import {ButtonActionControlRatio} from './button-action-control-ratio';
import {ButtonActionCreate} from './button-action-create-table-rows';
import {ButtonActionForDeleteRows} from './button-action-delete-rows';
import {ButtonActionDeleteTab} from './button-action-delete-tab/button-action-delete-tab';
import {ButtonsActionDocuments} from './button-action-documents';
import {ButtonActionForDownloadFileRows} from './button-action-dowland-file-rows';
import {ButtonActionEditFields} from './button-action-edit-field';
import {ButtonActionForTable} from './button-action-for-table';
import {ButtonActionForRows} from './button-action-for-table-rows';
import {ButtonActionRequests} from './button-action-requests';
import {ButtonActionSaveEditableModal} from './button-action-save-editable-modal';
import {ButtonActionSaveEditableTable} from './button-action-save-editable-table';
import {ButtonActionSaveRows} from './button-action-save-rows';
import {ButtonActionSaveTableRow} from './button-action-save-table-rows';
import {ButtonsActionSendRequest} from './button-action-send-request';
import {ButtonsActionUpdate} from './button-action-update-table';
import {ButtonActionUploadFile} from './button-action-upload-file';
import {ButtonActionUploadXml} from './button-action-upload-xml';
import {ButtonCancelChanges} from './button-cancel-changes';
import {ButtonDownloadSelectedRows} from './button-download-selected-rows';
import {OpenCryptoProSigningModal} from './button-open-crypto-pro-signing-modal';
import {ButtonUploadScanFiles} from './button-upload-scan-files';
import {ButtonsAction} from './buttons-action';
import {CheckboxCheckConfirm} from './checkbox-check-confirm';
import {DrillDownActionLink} from './drill-down-action-link';
import {Filter} from './filters';
import {GenerateTcResponse} from './generate-tc-response/generate-tc-response';
import {GenerateTcResponseNoRedirect} from './generate-tc-response/generate-tc-response-no-redirect';
import {OpenForm} from './open-form/open-form';
import {TableLaunchProgramModalAction} from './open-launch-program-modal';
import {TableOpenModalAction} from './open-modal';
import {Search} from './search';
import {TableSubmenuAction} from './submenu';

export const TABLE_ACTION_MAP = {
    [EMetaActionType.SUBMENU]: TableSubmenuAction,
    [EMetaActionType.OPEN_MODAL]: TableOpenModalAction,
    [EMetaActionType.LAUNCH_PROGRAM_BUTTON]: TableLaunchProgramModalAction,
    [EMetaActionType.OPEN_DOCUMENT_XML_MODAL]: OpenDocumentXmlModal,
    [EMetaActionType.OPEN_SYNTHESIS_DOCUMENT_MODAL]: SynthesisDocumentModalOpener,
    [EMetaActionType.OPEN_DWH_DATA_PREPARATION_MODAL]: DwhDataPreparationModalOpener,
    [EMetaActionType.OPEN_REQUESTS_CHILD_MODAL]: null,
    [EMetaActionType.FILTER]: Filter,
    [EMetaActionType.SEARCH]: Search,
    [EMetaActionType.BUTTON_ATTACHMENT]: AttachmentButton,
    [EMetaActionType.CREATE_LIST_CP]: ButtonsAction,
    [EMetaActionType.DOWNLOAD_REPORT]: ButtonsAction,
    [EMetaActionType.SEND_REMINDER]: ButtonsAction,
    [EMetaActionType.UNLOAD_CP]: ButtonsAction,
    [EMetaActionType.SUBMENU_OPTION]: null,
    [EMetaActionType.BUTTON_SAVE_FORM]: null,
    [EMetaActionType.BUTTON_CLEAN_FORM]: null,
    [EMetaActionType.BUTTON_FOR_CFT]: null,
    [EMetaActionType.LAUNCH_PROGRAM]: null,
    [EMetaActionType.BUTTON_SAVE_FORM_PERSONAL_ACCOUNT]: null,
    [EMetaActionType.BUTTON_SAVE_OR_EDIT_FORM]: ButtonSaveOrEditForm,
    [EMetaActionType.BUTTON_DOWNLOAD_SELECTED_ROWS]: ButtonDownloadSelectedRows,
    [EMetaActionType.BUTTON_DOWNLOAD_FILE]: null,
    [EMetaActionType.BUTTON_DOWNLOAD_DOCUMENT_FILE]: null,
    [EMetaActionType.BUTTON_ACTION_SAVE_TABLE_ROWS]: ButtonActionSaveTableRow,
    [EMetaActionType.BUTTON_SAVE_EDITABLE_MODAL]: ButtonActionSaveEditableModal,
    [EMetaActionType.BUTTON_SEND_FILTER]: null,
    [EMetaActionType.BUTTON_CONFIRM]: ButtonsAction,
    [EMetaActionType.ACTION_FOR_TABLE]: ButtonActionForTable,
    [EMetaActionType.ACTION_FOR_TABLE_ROWS]: ButtonActionForRows,
    [EMetaActionType.DOWNLOAD_TABLE_ROWS]: ButtonActionForDownloadFileRows,
    [EMetaActionType.DELETE_TABLE_ROWS]: ButtonActionForDeleteRows,
    [EMetaActionType.CLEAR_TABLE_ROWS]: ButtonActionForClearRows,
    [EMetaActionType.BUTTON_DOWNLOAD_ALL]: null,
    [EMetaActionType.BUTTON_CHANGE_REQUEST_STATUS]: null,
    [EMetaActionType.BUTTON_CONTROL_COLLAPSE]: null,
    [EMetaActionType.BUTTON_OPEN_MODAL_WITH_QUERY_PARAMS]: null,
    [EMetaActionType.UPLOAD_FROM_EXCEL]: ButtonActionUploadFile,
    [EMetaActionType.UPLOAD_FROM_XML]: ButtonActionUploadXml,
    [EMetaActionType.DOWNLOAD_TEMPLATE]: ButtonsAction,
    [EMetaActionType.DOWNLOAD_ALL_EXCEL]: ButtonsAction,
    [EMetaActionType.EDIT_FIELD]: ButtonActionEditFields,
    [EMetaActionType.BUTTON_SAVE_ROWS]: ButtonActionSaveRows,
    [EMetaActionType.DOWNLOAD_EXCEL]: ButtonsAction,
    [EMetaActionType.DOWNLOAD_XML]: ButtonsAction,
    [EMetaActionType.CHECKBOX_CONFIRM]: CheckboxCheckConfirm,
    [EMetaActionType.BUTTON_COPY_RULES_FROM_LAST_PERIOD]: ButtonsAction,
    [EMetaActionType.BUTTON_UPDATE]: ButtonsActionUpdate,
    [EMetaActionType.BUTTON_UPDATE_CP]: ButtonActionCreate,
    [EMetaActionType.BUTTON_SAVE_EDITABLE_TABLE]: ButtonActionSaveEditableTable,
    [EMetaActionType.BUTTON_BACK]: ButtonCancelChanges,
    [EMetaActionType.REMOVE_FILTER]: ButtonRemoveFilter,
    [EMetaActionType.UPDATE_DOCUMENTS_STATUS]: ButtonsActionDocuments,
    [EMetaActionType.PUBLISH_LIST]: ButtonsActionDocuments,
    [EMetaActionType.BUTTON_EDIT_FORM]: ButtonEditForm,
    [EMetaActionType.BUTTON_OPEN_LINK]: ButtonOpenLink,
    [EMetaActionType.BUTTON_SET_CORR_NUMBER]: ButtonSetCorrectionNumber,
    [EMetaActionType.BUTTON_SET_INITIAL_DATA]: ButtonsAction,
    [EMetaActionType.BUTTON_DELETE_ELEMENT]: ButtonsAction,
    [EMetaActionType.BUTTON_SWITCH_TABS]: null,
    [EMetaActionType.BUTTON_DELETE_TAB]: ButtonActionDeleteTab,
    [EMetaActionType.BUTTON_HISTORY_BACK]: ButtonHistoryBack,
    [EMetaActionType.BUTTON_REDIRECT]: ButtonRedirect,
    [EMetaActionType.BUTTON_DOWNLOAD_REPORT]: ButtonActionDownloadReport,
    [EMetaActionType.BUTTON_SET_EDIT_MODE]: null,
    [EMetaActionType.BUTTON_CLEAR_FORM]: null,
    [EMetaActionType.OPEN_FORM]: OpenForm,
    [EMetaActionType.BUTTON_OPEN_SIMPLE_MODAL]: null,
    [EMetaActionType.BUTTON_OPEN_SIMPLE_FILTER]: null,
    [EMetaActionType.SIMPLE_CHECKBOX]: null,
    [EMetaActionType.DOWNLOAD_ZIP_TABLE_ROWS]: ButtonsActionDocuments,
    [EMetaActionType.BUTTON_MARK_AS_READ]: ButtonActionRequests,
    [EMetaActionType.BUTTON_MARK_ALL_AS_READ]: ButtonActionRequests,
    [EMetaActionType.BUTTON_SEND_FOR_APPROVAL_REQUEST]: null,
    [EMetaActionType.BUTTON_SEND_TO_AGREEMENT]: null,
    [EMetaActionType.BUTTON_SEND_FOR_APPROVAL_REQUEST_DRAFT]: null,
    [EMetaActionType.BUTTON_SEND_COMMENT_ON_THE_REQUEST]: null,
    [EMetaActionType.GENERATE_TC_DEMAND_RESPONSE]: GenerateTcResponse,
    [EMetaActionType.GENERATE_TC_DEMAND_RESPONSE_NO_REDIRECT]: GenerateTcResponseNoRedirect,
    [EMetaActionType.CALCULATE_CONTROL_RATIO]: ButtonActionControlRatio,
    [EMetaActionType.CREATE_RESPONSE_DRAFT]: null,
    [EMetaActionType.CREATE_PROLONGATION_REQUEST_DRAFT]: null,
    [EMetaActionType.BUTTON_SAVE_FORM_DRAFT]: null,
    [EMetaActionType.OPEN_CRYPTO_PRO_SIGNING_MODAL]: OpenCryptoProSigningModal,
    [EMetaActionType.BUTTON_BLOCK_USER]: null,
    [EMetaActionType.UPLOAD_SCAN_FILES]: ButtonUploadScanFiles,
    [EMetaActionType.SEND_REQUEST]: ButtonsActionSendRequest,
    [EMetaActionType.SEND_SELECTED_DOCS_IDS]: ButtonsActionDocuments,
    [EMetaActionType.CUSTOM_LINK]: ButtonActionCustomLink,
    [EMetaActionType.SEND_REQUEST_COPY_RESPONSE_REQUIREMENT]: ButtonSendRequestCopyResponseRequirement,
    [EMetaActionType.SEND_REQUEST_WITH_USER]: ButtonsAction,
    [EMetaActionType.CUSTOM_LINK_TABLE_ROW]: DrillDownActionLink,
    [EMetaActionType.FORMATION_AGGREGATE]: ButtonFormation,
    [EMetaActionType.API_REQUEST_BUTTON]: ButtonsAction,
    [EMetaActionType.OPEN_FACTOR_INFLUENCE_INFO_ITEM_MODAL]: FactorInfluenceInfoItemModalOpener,
    [EMetaActionType.OPEN_FACTOR_INFLUENCE_INFO_SERVICE_MODAL]: FactorInfluenceInfoServiceModalOpener,
    [EMetaActionType.OPEN_FACTOR_INFLUENCE_INFO_DELETE_ROWS_MODAL]: FactorInfluenceInfoDeleteRowsModalOpener,
    [EMetaActionType.OPEN_PROJECT_INVESTMENT_SERVICE_MODAL]: ProjectInvestmentInfoServiceModalOpener,
    [EMetaActionType.OPEN_PROJECT_INVESTMENT_INFO_MODAL]: ProjectInvestmentInfoItemModalOpener,
    [EMetaActionType.OPEN_PROJECT_INFLUENCE_INFO_DELETE_ROWS_MODAL]: ProjectInvestmentInfoDeleteRowsModalOpener,
};
